module.exports = __webpack_public_path__ + "img/41.10ed54ed.png";